export function getNJIColours(){
  const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

  return DISTINCT
}
export function getNJIConfig() {
  const groupsById = {


      


    nji_ad_views: {
      type: "categorical",
      label: "Views on AI advertising",
      fulltext: "Which statement comes closest to your view? As AI-generated ads and messages become more common…",
      keys: [
  "ad_views.ad_accurate_pred_n",
  "ad_views.ad_authentic_pred_n",
  "ad_views.ad_quality_pred_n",
  "ad_views.ad_transparent_pred_n",
      ],
      labels: {
  "ad_views.ad_accurate_pred_n":"What matters most is whether the message is accurate - not whether AI was used to create it.",
  "ad_views.ad_authentic_pred_n":"Communications grounded in real people, authentic experiences, and true stories will become more valuable.",
  "ad_views.ad_quality_pred_n":"What matters most is that the ad is high-quality and professionally made, however it's produced.",
  "ad_views.ad_transparent_pred_n":"What matters most is that companies are transparent about when they use AI.",
      },
      schema:"tracking",
      waves: [4],
    },

  

        nji_ad_authentic: {
      type: "categorical",
      label: "Authenticity in AI advertising",
      fulltext: "Which of the following would most increase your trust that a company's advertisement or message is authentic? Please rank all of the following in order of importance.",
      keys: [
  "ad_authentic.prof_actor_pred_n",
  "ad_authentic.real_customer_pred_n",
  "ad_authentic.real_employee_pred_n",
  "ad_authentic.realistic_ai_pred_n",
      ],
      labels: {
  "ad_authentic.prof_actor_pred_n":"It features a professional actor delivering a well-crafted message.",
  "ad_authentic.real_customer_pred_n":"It features a real customer or community member sharing their own experience.",
  "ad_authentic.real_employee_pred_n":"It features a real employee, leader, or expert with relevant knowledge.",
  "ad_authentic.realistic_ai_pred_n":"It features a realistic AI-generated person delivering the message.",
      },
      schema:"tracking",
      waves: [4],
    },
    
        nji_content_trust: {
      type: "categorical",
      label: "Trust in AI advertising",
      fulltext: "As AI-generated content becomes more common, which of the following do you think will matter most in determining whether you trust an organization's communications or advertising? Please rank all of the following in order of importance.",
      keys: [
  "content_trust.authentic_pred_n",
  "content_trust.emotional_connection_pred_n",
  "content_trust.factual_pred_n",
  "content_trust.real_people_pred_n",
  "content_trust.transparent_pred_n"
      ],
      labels: {
  "content_trust.authentic_pred_n":"The communication feels authentic and genuine.",
  "content_trust.emotional_connection_pred_n":"The communication creates an emotional connection.",
  "content_trust.factual_pred_n":"The information is factual, accurate, and can be verified.",
  "content_trust.real_people_pred_n":"The message is based on real people, real experiences, or true stories.",
  "content_trust.transparent_pred_n":"The organization is transparent about its use of AI."
      },
      // Pinned to the slide-2 chart palette so the map and the bar chart never
      // disagree: navy = factual, teal = AI disclosure, indigo = the three
      // human-centered statements (which the story treats as one bloc).
      colors: {
  "content_trust.factual_pred_n":"#1a5276",
  "content_trust.transparent_pred_n":"#0d9488",
  "content_trust.real_people_pred_n":"#6366f1",
  "content_trust.authentic_pred_n":"#6366f1",
  "content_trust.emotional_connection_pred_n":"#6366f1",
      },
      schema:"tracking",
      waves: [4],
    },

    nji_ad_reaction: {
      type: "likert",
      label: "Reaction to AI advertising",
      fulltext: "Suppose you saw an ad you liked, and later learned the person in it was AI-generated rather than a real person. Which best describes how you would react?",
      keys: [
  "ai_reaction.ai_not_bothered_pred_n",
  "ai_reaction.ai_somewhat_less_pred_n",
   "ai_reaction.ai_much_less_pred_n",
  "ai_reaction.ai_stop_buying_pred_n",
   "ai_reaction.ai_not_sure_pred_n",
      ],
      labels: {
  "ai_reaction.ai_not_bothered_pred_n":"It wouldn't bother me",
  "ai_reaction.ai_somewhat_less_pred_n":"I'd trust that brand somewhat less",
    "ai_reaction.ai_much_less_pred_n":"I'd trust that brand much less",
  "ai_reaction.ai_stop_buying_pred_n":"I'd stop buying from that brand",
   "ai_reaction.ai_not_sure_pred_n":"Not sure",
      },
      // NOTE: "I'd trust that brand somewhat less" is a NEGATIVE reaction. It was
      // previously listed under `pos`, which understated combined negative by 20.6pts
      // nationally (32.1% instead of 52.7%) and inverted the choropleth ramp.
      polarity: {
        pos: [
  "ai_reaction.ai_not_bothered_pred_n",
        ],
        neu: ["ai_reaction.ai_not_sure_pred_n"],
        neg: [
  "ai_reaction.ai_somewhat_less_pred_n",
    "ai_reaction.ai_much_less_pred_n",
  "ai_reaction.ai_stop_buying_pred_n",
        ],
      },
      schema:"tracking",
      waves: [4],
    },

        ai_use: {
      type: "categorical",
      label: "AI Use",
      fulltext: "How often do you personally use AI tools (such as ChatGPT, Claude, or Gemini)?",
      keys: [
  "model_ai_use_daily_pred_n",
  "model_ai_use_weekly_pred_n",
  "model_ai_use_rarely_never_pred_n",
      ],
      labels: {
  "model_ai_use_daily_pred_n":"Daily",
  "model_ai_use_weekly_pred_n":"Weekly/Monthly",
  "model_ai_use_rarely_never_pred_n":"Rarely/Never",
      },
      schema:"tracking",
      waves: [4],
    },

    pol_midterm_vote_choice: {
      type: "categorical",
      label: "Midterm voting intention",
      subgroup: "Political",
      core: true,
      fulltext: "Thinking ahead to the Midterm elections next November - who do you think you will vote for?",
      keys: [
        "midterms_VI_dem",
        "midterms_VI_rep",
        "midterms_VI_other",
        "midterms_VI_notsure_wnv",
      ],
      labels: {
        "midterms_VI_dem":          "Democrat",
        "midterms_VI_rep":          "Republican",
        "midterms_VI_other":        "Other",
        "midterms_VI_notsure_wnv":  "Not sure / Would not vote",
      },
      colors: {
        "midterms_VI_dem":         "#0057B7",
        "midterms_VI_rep":         "#D52B1E",
        "midterms_VI_other":       "#CCCCCC",
        "midterms_VI_notsure_wnv": "#888888",
      },
      aggregation_column: "TURNOUT_N",
      // Backdrop for the NJI highlights reel only: never listed in the
      // dashboard sidebar or mobile question picker.
      hidden: true,
      hidden_in_demo: true,
      schema: "tracking",
      waves: [2, 3],
    },

  };

  
  return {  groupsById };
}
const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = g.full_labels?.[k] || g.labels?.[k] || k;

      if (!colors[k]) {
        if (g.colors?.[k]) {
          colors[k] = g.colors[k];
        } else if (g.type === "likert") {
          colors[k] = baseColorForLikertKey(g, k);
        } else {
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }

  return { labels, colors };
}


export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

  export function baseColorForLikertKey(group, key) {
    const pol = group?.polarity || {};

    const tag = Object.entries(pol).find(([_, polKey]) => {
      if (Array.isArray(polKey)) return polKey.includes(key);
      return polKey === key;
    })?.[0];

    if (tag === "pos") return "#2E7D32";
    if (tag === "neg") return "#C62828";
    if (tag === "neu") return "#bab0ab"; // optional: distinguish neutral from fallback
    return "#6e6e6e";
  }

// Tab-as-config default export
export default {
  tab: "nji",
  label: "nji",
  get metrics() { return getNJIConfig().groupsById; },
};

